import moment from "moment";
import * as React from "react";
import { Idevice } from "../../types/device";

interface IComaprisonSearchProps {
	oneBoxContent: {
		type: string;
		tab: string;
		action: string;
		data: {
			stkDet: Array<{}>;
		};
	};
	deviceState: Idevice;
}

export function ComaprisonSearch(props: IComaprisonSearchProps) {
	return (
		<>
			{props.oneBoxContent.data.stkDet.map((comp: any, index: number) => (
				<div className="oneboxResults searchRes" key={index}>
					<div className={"mg-b10 " + (props.oneBoxContent.type === "datapoint" ? "pd-l15" : "")}>
						<a className="AsearchHeader" href={comp.url}>
							<span className="search-comp">{comp.nm}</span>
						</a>
						<p className="AsearchStockNo">
							<span>{comp.ltp}</span>&nbsp;
							<span className="mg-110">
								<i
									className={
										"fa mg-110 " + (parseFloat(comp.chgP) >= 0 ? "ed-green edel-icon-caret-up" : "ed-red edel-icon-caret-down")
									}
								></i>
							</span>
							&nbsp;&nbsp;
							<span className={"ATBold mg-110 " + (parseFloat(comp.chgP) >= 0 ? "ed-green" : "ed-red")}>
								{comp.chg + " (" + comp.chgP + " % )"}
							</span>
							&nbsp;
							<span className="edel-icon-timer"></span>
							&nbsp;
							<span className="time">{moment(comp.ltt).format("MMM DD, hh:mm a")}</span>
						</p>
					</div>
					<div id="obr" className={props.oneBoxContent.type === "datapoint" && props.deviceState.isDesktop ? "by2 cols" : ""}>
						<div>
							<table className="table">
								<tbody className="ATFont14">
									<tr>
										<td>Market Cap</td>
										<td className="ATBold AtRight">{comp.mCap}</td>
									</tr>
									<tr>
										<td>BV</td>
										<td className="ATBold AtRight">{comp.bv}</td>
									</tr>
									<tr>
										<td>P/E</td>
										<td className="ATBold AtRight">{comp.pe}</td>
									</tr>
									<tr>
										<td>Dividend Yield</td>
										<td className="ATBold AtRight">{comp.dy}</td>
									</tr>
									<tr>
										<td>EV/EBITDA</td>
										<td className="ATBold AtRight">{comp.eveb}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div>
							<table className="table">
								<tbody className="ATFont14">
									<tr>
										<td>P/BV</td>
										<td className="ATBold AtRight">{comp.pbv}</td>
									</tr>
									<tr>
										<td>ROC</td>
										<td className="ATBold AtRight">{comp.roc}</td>
									</tr>
									<tr>
										<td>Debt to Equity Ratio</td>
										<td className="ATBold AtRight">{comp.de}</td>
									</tr>
									<tr>
										<td>ROE</td>
										<td className="ATBold AtRight">{comp.roe}</td>
									</tr>
									<tr>
										<td>3 Year CAGR Sales</td>
										<td className="ATBold AtRight">{parseFloat(comp.cagr).toFixed(2)}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			))}
		</>
	);
}

export default ComaprisonSearch;
